import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = {
    message: {
      /* 用户信息采集 */
      'tips':'提示',
      'name':'姓名',
      'tel':'电话',
      'email':'邮箱',
      'company':'公司',
      'seriesofinterest':'感兴趣的系列',
      'incorrectformat!':'格式有误!',
      'pleaseenter':'请输入',
      'submit':'确定',
      'reset':'重置',
      /* ——————————— */
      'title_01' : '电机选择',
      'title_02' : '负载选择',
      'title_03' : '应用选择',
      'title_04' : '减速机选择',
      'title_05' : '转动惯量计算器',
      'homepage' : '首页',
      'product'  : '产品',
      'Selectionofparameters' : '减速机选择',
      'motor' : '选定电机',
      'ratio' : '选定系列·减速比',
      'size' : '选定减速机型号',
      'complete' : '选定完成',
      'motorSelection': '电机选择',
      'Manufacturers': '选定电机厂商',
      'Type': '选定电机型号',
      'Return':'上一步',
      'Next': '下一步',
      'reducerList':'减速机系列详情表',
      'reducerSeries':'选定减速机系列',
      'reductionRatio':'选定系列减速比',
      'manufacturer':'电机厂商',
      'model':'电机型号',
      'series':'减速机系',
      'selectSizeInfo' : '请选择减速机型号',
      'Information' : '资料页',
      'DecelerationDimensionDetails' : '减速机型号详情',
      'ReducerModel' : '减速机型号',
      'Info' : '根据外观请参考实物',
      'Dso':'下载规格书·外形图',
      'DecelerationDimensionDetails':'减速机型号详情',
      'clickDownload':'点击下载',
      'InstallMotor':'安装电机',
      'motorSpecifications':'电机规格',
      'notes':'注意事项',
      'returnIndex':'返回首页',
      'selectedSeries':'选定系列',
      'loadCondition':'减速机负载',
      'reducerSize':'减速机型号',
      'selectMotor':'选择电机',
      'reducer':'减速机系列:',
      'info01':'请选择减速比',
      'info02':'请选择运转模式数(n数)',
      'info03':'请输入负载条件',
      'info04':'请输入使用系数KA',
      'info05':'技术图纸',
      'info06':'请选择减速机系列',
      'info07':'减速机型号-级数-电机尺寸',
      'info08':'1. 快速频繁正反转，且惯量大请考虑工况系数，选择低侧隙产品。',
      'info09':'2. 减速机输出转速低于1rpm时，内部的油脂会出现润滑不良，请咨询我公司技术人员。',
      'info10':'3. 142以上减速机与电机的长度比（电机/减速机）在2以上，电机侧会出现震动，特别是接齿轮与皮带轮，请做结构加强措施。',
      'info11':'4. 选型结果仅供参考，如没有足够经验判断选型是否准确，请咨询我公司技术人员。',
      'info12':'如果没有可用减速机，请修改扭矩等值',
      'info13':'(该方法为粗略估计，请用流程2或3精确计算)',
      'title01':'输出扭矩(Nm)',
      'title02':'输出转速(r/min)',
      'title03':'作用时间(s)',
      'title04':'径向负重(N) ',
      'title05':'轴向负重(N) ',
      'title06':'径向作用距离(mm)',
      'title07':'轴向作用距离(mm) ',
      'Reducersystem':'减速机系:',
      'title08':'选定电机厂商',
      'title09':'选定电机型号',
      'title10':'系列名',
      'title11':'减速比',
      'note01':'1.您使用的电机厂商在一览表中不存在时，请询问我公司',
      'note02':'2.您使用的电机在一览表中不存在时，请询问我公司',
      'note03':'3.请在确认减速机的效率特性后，再做电机的选型',
      'ApplicationSelection' : '应用选择',
      'AppLoadconditions':'应用负载',
      'ReducerLoadconditions':'减速机负载',
      'Operationmode':'运转模式',
      'ReducerModelTable':'减速机型号表',
      'SelectedSeriesName':'选定系列名',
      'SelectedSpecifications':'选定规格',
      'SelectedSeries':'选定级数',
      'Selecteddecelerationratio':'选定减速比',
      'SelectMotorSize':'选定电机尺寸',
      'WhetherWithAKey':'输入是否带键槽',
      'CalculationInertia':'转动惯量计算',
      'TypeSelection':'类型选择',
      'ParameterInput':'参数输入',
      'ComputationalResults':'计算结果',
      'DensityReference':'密度参考',
      'Compute':'计算',
      'CylinderVertical': '圆柱体-垂直',
      'Square': '方形',
      'CylinderParallel': '圆柱体-平行',
      'BallScrew': '滚珠丝杆',
      'spherical': '球形',
      'cake': '饼状',
      'arbitraryObject': '任意物体',
      'compute1':'内径',
      'compute2':'外径',
      'compute3':'长度',
      'compute4':'密度',
      'compute5':'重心线与旋转轴线距离',
      'compute6':'物体质量',
      'compute7':'物体惯性',
      'compute8':'宽度',
      'compute9':'高度',
      'compute10':'导程',
      'compute11':'直径',
      'compute12':'厚度',
      'compute13':'惯量',
      'compute14':'质量',
      'returnApp':'返回应用选择',
      'GearboxModel':'减速机型号',
      'Judge':'判定',
      'Stage':'级别',
      'Note':'备注',
      'Life':'寿命(h)',
      'NG':'不可用',
      'OK':'可用',
      'complete_title_01':'减速比',
      'complete_title_02':'抗扭刚性',
      'complete_title_03':'故障停止扭矩',
      'complete_title_04':'最大轴向力',
      'complete_title_05':'最大径向力',
      'complete_title_06':'最大转速',
      'complete_title_07':'额定转速',
      'complete_title_08':'转动惯量',
      'complete_title_09':'额定输出扭矩',
      'complete_title_10':'平均寿命',
      'complete_title_11':'满载效率',
      'complete_title_12':'电机厂商',
      'complete_title_13':'电机型号',
      'complete_title_14':'功率',
      'complete_title_15':'转动惯量',
      'complete_title_16':'额定转速',
      'complete_title_17':'最高转速',
      'complete_title_18':'峰值扭矩',
      'complete_title_19':'轴直径C3',
      'complete_title_20':'轴到面长C4',
      'complete_title_21':'安装止口C5',
      'complete_title_22':'止口长C6',
      'complete_title_23':'最小分布圆C1-1',
      'complete_title_21':'最大分布圆C1-2',
      'complete_title_22':'螺纹C2',
      'complete_title_23':'安装方式',
      'RotaryTable':'转台',
      'ConveyorBelt':'传送带',
      'PinionandRack':'齿轮齿条',
      'LiftingandLoweringDevice':'升降装置',
      'AGVcar':'AGV小车',
      'SrewDrive':'丝杆传动',
      'GearDrive':'齿轮传动',
      'SynchronousBeltDrive':'同步带传动',
      'zhuantai_1':'转台',
      'zhuantai_2':'转台半径',
      'zhuantai_3':'转台质量',
      'zhuantai_4':'负载半径',
      'zhuantai_5':'负载质量',
      'zhuantai_6':'负载距离',
      'zhuantai_7':'和减速机的连接方式',
      'zhuantai_8':'直接结合',
      'zhuantai_9':'连轴器',
      'zhuantai_10':'转台轴承直径',
      'zhuantai_11':'轴承摩擦系数',
      'zhuantai_12':'加速时间',
      'zhuantai_13':'匀速时间',
      'zhuantai_14':'减速时间',
      'zhuantai_15':'停止时间',
      'zhuantai_16':'速度',
      'chuansongdai_1':'传送带',
      'chuansongdai_2':'传送重量',
      'chuansongdai_3':'传动带轮直径',
      'chuansongdai_4':'输送机倾斜角度',
      'chuansongdai_5':'皮带张力',
      'chuansongdai_6':'摩擦扭矩',
      'chitiao_1':'齿轮齿条',
      'chitiao_2':'工作台重量',
      'chitiao_3':'工作台倾斜角度',
      'chitiao_4':'工件重量',
      'chitiao_5':'齿轮节圆',
      'chitiao_6':'驱动齿轮个数',
      'chitiao_7':'螺旋角',
      'chitiao_8':'工作台摩擦系数',
      'shengjiang_1':'升降装置',
      'shengjiang_2':'工件重量',
      'shengjiang_3':'砝码重量',
      'shengjiang_4':'链轮重量',
      'shengjiang_5':'总转动惯量',
      'shengjiang_6':'摩擦扭矩',
      'shengjiang_7':'和减速机的连接方式',
      'shengjiang_8':'直接结合',
      'shengjiang_9':'链轮',
      'shengjiang_10':'减速机链轮节圆',
      'shengjiang_11':'升降装置链轮节圆',
      'shengjiang_12':'链轮节圆',
      'agv_1':'AGV小车',
      'agv_2':'车货总重',
      'agv_3':'车轮直径',
      'agv_4':'单个驱动轮负重',
      'agv_5':'驱动轮个数',
      'agv_6':'坡度',
      'agv_7':'轮轴摩擦系数',
      'agv_8':'支撑方式',
      'agv_9':'车轮独立支撑',
      'agv_10':'直接连接',
      'sigan_1':'丝杆传动',
      'sigan_2':'螺距',
      'sigan_3':'工作台倾斜角度',
      'sigan_4':'工作台总质量',
      'sigan_5':'工作台摩擦系数',
      'sigan_6':'丝杆转动惯量',
      'chuandong_1':'齿轮传动',
      'chuandong_2':'齿轮1节圆',
      'chuandong_3':'齿轮2节圆',
      'chuandong_4':'齿轮1转动惯量',
      'chuandong_5':'齿轮2总转动惯量',
      'chuandong_6':'螺旋角',
      'chuandong_7':'齿轮1扭矩',
      'tongbudai_1':'同步带传动',
      'tongbudai_2':'同步带1节圆',
      'tongbudai_3':'同步带2节圆',
      'tongbudai_4':'同步带1转动惯量',
      'tongbudai_5':'同步带2总转动惯量',
      'tongbudai_6':'同步张力',
      'tongbudai_7':'同步带1扭矩',
      'ReducerList_1':'级数',
      'ReducerList_2':'减速比',
      'ReducerList_3':'额定输出扭矩(Nm)',
      'ReducerList_4':'故障停止扭矩',
      'ReducerList_5':'最大径向力(N)',
      'ReducerList_6':'最大轴向力(N)',
      'ReducerList_7':'满载效率(%)',
      'ReducerList_8':'平均寿命(h)',
      'ReducerList_9':'转动惯量(kgc㎡)',
      'ReducerList_10':'单级回程间隙(arcmin)',
      'ReducerList_11':'抗扭刚性(Nm/arcmin)',
      'ReducerList_12':'噪音(dB(A))',
      'ReducerList_13':'最大输入速度(Nm/arcmin)',
      'ReducerList_14':'额定输入速度(min-1)',
      'ReducerList_15':'重量(kg)',
      'ReducerList_16':'抗扭刚性(Nm/arcmin)',
      'ReducerList_17':'2倍额定输出',
      'ReducerList_18':'3倍额定输出',
      'ReducerList_19':'下载技术参数',
      'ReducerList_20':'K系列减速机',
      'ReducerList_21':'S系列减速机',
      'ReducerList_22':'其他系列减速机',
      'ReducerList_23':'KT系列减速机',
      'finish_1':'减速比',
      'finish_2':'抗扭刚性',
      'finish_3':'故障停止扭矩',
      'finish_4':'最大轴向力',
      'finish_5':'最大径向力',
      'finish_6':'最大转速',
      'finish_7':'额定转速',
      'finish_8':'转动惯量',
      'finish_9':'额定输出扭矩',
      'finish_10':'平均寿命',
      'finish_11':'满载效率',
      'finish_12':'电机厂商',
      'finish_13':'电机型号',
      'finish_14':'额定输出扭矩',
      'finish_15':'功率',
      'finish_16':'转动惯量',
      'finish_17':'额定转速',
      'finish_18':'最高转速',
      'finish_19':'峰值扭矩',
      'finish_20':'轴直径C3',
      'finish_21':'轴到面长C4',
      'finish_22':'安装止口C5',
      'finish_23':'止口长C6',
      'finish_24':'最小分布圆C1-1',
      'finish_25':'最大分布圆C1-2',
      'finish_26':'减速机螺纹孔',
      'finish_27':'安装方式',
      'finish_28':'最大输入转速',
      'finish_29':'平均输入转速',
      'finish_30':'最大输出扭矩',
      'finish_31':'平均输出扭矩',
      'finish_32':'平均径向力',
      'finish_33':'最大径向力',
      'finish_34':'平均轴向力',
      'finish_35':'最大轴向力',
      'ie_text':'您的浏览器版本过低 请安装chrome浏览器进行访问',
      'ie_download':'立即下载',
      'CycleNumberHour':'周期次数/小时',
      'systemName':'减速机选型系统',
      'fileDownLoad':'说明书下载'
    },
    ...zhLocale
}
export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js